var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxBlankLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_unchecked)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 1.33203H4.00065C2.52789 1.33203 1.33398 2.52594 1.33398 3.9987V11.9987C1.33398 13.4715 2.52789 14.6654 4.00065 14.6654H12.0007C13.4734 14.6654 14.6673 13.4715 14.6673 11.9987V3.9987C14.6673 2.52594 13.4734 1.33203 12.0007 1.33203Z",
    fill: "none",
    stroke: "#484888",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_unchecked"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxBlankLine);
export default __webpack_public_path__ + "static/media/checkbox-blank-line.2756896cc097fe21f2348e0ec1fb0c44.svg";
export { ForwardRef as ReactComponent };